import React from 'react';
import { Footer } from './footer';
import { Navbar } from './navbar';
export var HubAppShell = function HubAppShell(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Navbar, null), children, /*#__PURE__*/React.createElement(Footer, null));
};